import api from 'services/api';
import { AxiosResponse } from 'axios';

import { iUpdateModalParams } from '../components/Modal/types';

export const getNotificationAPI = (
  codeClient: number
): Promise<AxiosResponse<any>> => {
  return api.get(`Comunicacao?CodigoCliente=${codeClient}&CodigoStatus=1`);
};

export const updateNotificationAPI = (
  params: iUpdateModalParams
): Promise<AxiosResponse<any>> => {
  return api.put('Comunicacao', { ...params });
};
